import { render, staticRenderFns } from "./BDashboardWidget.vue?vue&type=template&id=57d89b96&scoped=true"
import script from "./BDashboardWidget.vue?vue&type=script&lang=js"
export * from "./BDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./BDashboardWidget.vue?vue&type=style&index=0&id=57d89b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d89b96",
  null
  
)

export default component.exports